"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
const i18next_1 = __importDefault(require("i18next"));
const errors_1 = require("@/common/errors");
const eggs_1 = require("@/common/eggs");
function default_1({ error, confirm }) {
    var _a, _b;
    const errorCode = (_b = (_a = error.response.data) === null || _a === void 0 ? void 0 : _a.meta) === null || _b === void 0 ? void 0 : _b.alert_type;
    switch (errorCode) {
        case 40001:
            (0, errors_1.notFoundConfirm)({ confirm });
            break;
        case 40004:
            confirm({
                description: `${i18next_1.default.t('작가님이 커미션 오픈을 종료하셨어요')}🥺`,
                cancellationButtonProps: { style: { display: 'none' } },
            });
            break;
        case 40006:
            (0, eggs_1.preventMyself)({ confirm, message: i18next_1.default.t('스스로 신청하지 말아요') });
            break;
        default:
            alert((0, errors_1.commonErrorMsg)() + ` (에러코드: ${errorCode})`);
    }
}
exports.default = default_1;
